import styled from 'styled-components';

export const Quote = styled.div`
  padding-bottom: 8px;
  position: relative;

  table {
    margin: 16px 0%;
  }

  .text-invisible{
    height: 0;
    text-indent: -99999999px;
  }
`;

export const Container = styled.div`
  ${Quote}:not(:first-of-type) {
    margin-top: 32px;
    padding-top: 32px;
    margin-bottom: 24px;
    border-top: solid 1px #4b4e53;
  }

  .price {
    top: 12px;
    width: 600px;
    position: relative;
  }

  .buttons {
    right: 0px;
    width: 180px;
    bottom: -8px;
    margin-left: 16px;
    position: absolute;
  }
`;
